import { API_URL } from "config";
import Http from "util/https";
import { CsvUploadOrderAskResponseApi } from "../types/index";

/**
 * 注文RPACSVアップロードApi
 * @param args RPACSVアップロードApiのパラメータ
 * @returns CSVCountCheckStock[]
 */
export default async function uploadRPACsv(args: { csv_file: File }) {
  const params = {
    csv_file: args.csv_file,
  };
  // ファイル送信
  const http = Http.default.alterAuth({useToken: true, useFormData: true});
  const url = `${API_URL}/order/product/bo/csv/upload`;
  await http.post<CsvUploadOrderAskResponseApi>(url, Http.convertObjectToFormData(params));
}
